import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router";
import { useAuth, useLinks, useTeam } from "hooks";
import { SideNavExpander, SideNavLink } from "components/Nav/SideNav";
import { ICON_TYPE } from "components/Icon";

/**
 * MenuItemSquads
 *
 * @param {Object}   team
 * @param {Array}    subNavItems
 */
const MenuItemSquads = ({ team, subNavItems, ...props }) => {
  const { id } = useParams();
  const { isShowcase, isClient, isSignalClient, teams } = useAuth();
  const links = useLinks();
  const [expandedTeamSlug, setExpandedTeamSlug] = useState(
    isShowcase || isSignalClient ? teams[0].slug : isClient ? id : null
  );
  const { teamPermissions, permissionsLoading } = useTeam({ id: team?.slug });
  const navItems = subNavItems || DEFAULT_SQUAD_NAVIGATION(team?.slug, links);

  return isShowcase || isClient || isSignalClient ? (
    <SideNavExpander
      key={team?.slug}
      icon={ICON_TYPE.network}
      data={team}
      items={permissionsLoading ? [] : navItems?.filter((item) => teamPermissions?.[item.permissionKey])}
      gradientLabel={isShowcase && <FormattedMessage id="Nav.SideNav.Live" />}
      isExpanded={team?.slug === expandedTeamSlug}
      onToggle={() => {
        if (team?.slug === expandedTeamSlug) {
          setExpandedTeamSlug(null);
        } else {
          setExpandedTeamSlug(team?.slug);
        }
      }}
      {...props}
    />
  ) : (
    <SideNavLink key={team?.slug} type={ICON_TYPE.network} to={links.squad(team?.slug)} routerEnabled>
      {team?.name}
    </SideNavLink>
  );
};

const DEFAULT_SQUAD_NAVIGATION = (slug, links) => [
  {
    id: "profile",
    title: <FormattedMessage id="Nav.SideNav.Squads.Overview" />,
    link: links.squad(slug),
    icon: ICON_TYPE.analytics,
    permissionKey: "canAccessProfile",
  },
  {
    id: "insights",
    title: <FormattedMessage id="Nav.SideNav.Squads.Insights" />,
    link: links.squad_insights(slug),
    icon: ICON_TYPE.analytic,
    permissionKey: "canAccessInsights",
  },
  {
    id: "engineering",
    title: <FormattedMessage id="Nav.SideNav.Squads.Engineering" />,
    link: links.squad_engineering(slug),
    icon: ICON_TYPE.status,
    permissionKey: "canAccessEngineering",
  },
  {
    id: "effort_report",
    title: <FormattedMessage id="Nav.SideNav.Squads.EffortReport" />,
    link: links.squad_effort_report(slug),
    icon: ICON_TYPE.timerStart,
    permissionKey: "canAccessEffortReport",
  },
  {
    id: "daily_report",
    title: <FormattedMessage id="Nav.SideNav.Squads.DailyReport" />,
    link: links.squad_daily_report(slug),
    icon: ICON_TYPE.file,
    permissionKey: "canAccessDailyReport",
  },
  {
    id: "settings",
    title: <FormattedMessage id="Nav.SideNav.Squads.Settings" />,
    link: links.squad_settings(slug),
    icon: ICON_TYPE.gear,
    permissionKey: "canAccessSettings",
  },
];

MenuItemSquads.propTypes = {
  team: PropTypes.object.isRequired,
  subNavItems: PropTypes.array,
};

export default MenuItemSquads;
